module.exports = __webpack_public_path__ + "fonts/GothamBold.722c5f89.otf";